import { Typography, Skeleton } from '@ui/components';
import { PropsWithChildren, FC } from 'react';

export const LabeledText: FC<
  PropsWithChildren<{ isLoading?: boolean; className?: string; label: string }>
> = ({ label, children, isLoading, className }) => {
  return (
    <div className="flex flex-col gap-1">
      <Typography variant="labelMediumMedium" className="text-weak" element="label">
        {label}
      </Typography>
      {isLoading ? (
        <Skeleton className="h-10 w-1/2" />
      ) : (
        <Typography className={className} element="span" variant="h500">
          {children}
        </Typography>
      )}
    </div>
  );
};
